import React from 'react';
import queryString from 'query-string';
import { Form, InputGroup } from 'react-bootstrap';
import { ChangeLocation, Touchable } from 'components';
import { func, images, types } from 'utils';
import { RouteComponentProps, useParams } from 'react-router';
import {
	IonButtons,
	IonHeader,
	IonTitle,
	IonToolbar,
	useIonRouter,
} from '@ionic/react';
import { _store, _update } from '_Store';

interface Params {
	id: string;
}
interface StateProps {
	showBack?: boolean;
	showSearch?: boolean;
	showSegments?: boolean;
	showAddress?: boolean;
	search?: {
		placeholder?: string;
		onSearch?: (input: string) => void;
	};

	goBack?: () => void;
}
interface Props extends RouteComponentProps, types.StateProps, StateProps {}
const Header: React.FC<Props> = (props) => {
	const params: Params = useParams();
	const router = useIonRouter();

	const { history, showSearch, search } = props;
	const showBack =
		typeof props.showBack === 'undefined' ? true : props.showBack;
	const showAddress =
		typeof props.showAddress === 'undefined' ? true : props.showAddress;
	const {
		__data: { location, is_bottom_modal, activeStore },
	} = _store.useState();

	const [goBack, showGoBack] = React.useState(false);
	const [changeLocation, setChangeLocation] = React.useState(false);

	let qs = queryString.parse(history.location.search);

	React.useEffect(() => {
		if (history.location.pathname !== '/' && location.address.name) {
			showGoBack(false);
		} else {
			showGoBack(!!props.showBack);
		}
		// if (
		// 	!history.location.pathname.includes('promo') &&
		// 	!history.location.pathname.includes('coupon') &&
		// 	!history.location.pathname.includes('outlet') &&
		// 	location.option === types.OrderTypes.PROMOS
		// ) {
		// 	_update.data('location', { option: 'dine' });
		// }
		if (
			!history.location.pathname.includes('/orders/') &&
			!history.location.pathname.includes('/rate/') &&
			!history.location.pathname.includes('/help/')
		) {
			_update.data('order', {});
		}
		if (!history.location.pathname.includes('/i/')) {
			_update.data('item', {});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [history.location.pathname]);

	const canGoBack = history.location.pathname !== '/home' && showBack;

	return (
		<React.Fragment>
			<IonHeader
				id="Header"
				className={`ion-no-border ${func.isMobile ? 'isMobile' : ''} ${is_bottom_modal.is_open ? 'd-nones' : ''}`}
			>
				<IonToolbar>
					{canGoBack && (
						<IonButtons slot="start">
							<Touchable
								shape="circle"
								onClick={() => {
									if (props.goBack) {
										props.goBack();
									} else {
										history.goBack();
									}
								}}
								className="pl-1s"
							>
								<div className="pl-1s">
									<img src={images.ArrowLeftCircle} alt="ArrowLeftCircle" />
								</div>
							</Touchable>
						</IonButtons>
					)}
					<IonTitle className={`${canGoBack ? 'pl-0' : ''}`}>
						{showAddress && !history.location.pathname.includes(`location`) && (
							<>
								{history.location.pathname.includes(`home`) ? (
									<div
										className={`d-flex align-items-center small ${!showSearch ? 'mb-3s' : ''} `}
									>
										<img src={images.Location2} alt="Location" />
										<div className="ml-2">
											<Touchable onClick={() => setChangeLocation(true)}>
												<div className="d-flex align-items-center">
													<div
														className="fw-600 text-truncate"
														style={{ maxWidth: '50vw' }}
													>
														{location.address.name || 'N/A'}.
													</div>
													<i className="fa fa-chevron-down" />
												</div>
												{location.address.city && (
													<div className="text-muted">
														{location.address.city}
													</div>
												)}
											</Touchable>
										</div>
									</div>
								) : (
									<div
										className={`d-flex align-items-center small ${!showSearch ? 'mb-3s' : ''} `}
									>
										<img src={images.Location2} alt="Location" />
										<div className="ml-2">
											<div className="fw-600">
												{func.venueName(activeStore)}
											</div>
											<div
												className="text-muted text-truncate"
												style={{ maxWidth: '50vw' }}
											>
												{location.address.name}
											</div>
										</div>
									</div>
								)}
							</>
						)}
					</IonTitle>
					<IonButtons slot="end">
						<div
							className="d-flex justify-content-end"
							style={{ width: '76%' }}
						>
							<img
								src={images.Logo}
								alt="Chicken republic logo"
								style={{ height: '2rem' }}
							/>
						</div>
					</IonButtons>
				</IonToolbar>

				{showSearch && (
					<div
						id="HeaderSearch"
						className={`${is_bottom_modal.is_open ? 'd-nones' : 'd-flex'} px-3 pb-3 mt-3`}
					>
						<div className="d-flex">
							{goBack && (
								<div
									className="d-flex align-items-center pointer"
									style={{ width: '10vw' }}
									onClick={() => {
										history.goBack();
									}}
								>
									<img src={images.ArrowLeftCircle} alt="ArrowLeftCircle" />
								</div>
							)}
							<div style={{ width: 'calc(100vw - 2rem)' }}>
								<Form.Group className="w-100">
									<InputGroup>
										<InputGroup.Prepend>
											<InputGroup.Text className="border-right-0">
												<img
													src={images.Search}
													alt="Search"
													className="img-fluid"
												/>
											</InputGroup.Text>
										</InputGroup.Prepend>
										<Form.Control
											className="border-left-0"
											type="search"
											name="q"
											defaultValue={(qs.q || '') as string}
											placeholder={search?.placeholder || 'Search meals'}
											required
											autoComplete="off"
											size="lg"
											onKeyUp={(e: any) => {
												if (
													e?.key?.toLowerCase() === 'enter' ||
													e.keyCode === 13
												) {
													if (e.target.value) {
														if (!search?.onSearch) {
															router.push(
																`/search?q=${e.target.value}${history.location.pathname.includes('/c/') ? `&category=${params.id}` : ''}`
															);
														} else {
															search.onSearch(e.target.value);
														}
													}
												}
											}}
											onChange={(e) =>
												search?.onSearch && search.onSearch(e.target.value)
											}
										/>
									</InputGroup>
								</Form.Group>
							</div>
						</div>
					</div>
				)}

				{changeLocation && (
					<ChangeLocation
						changeLocation={changeLocation}
						setChangeLocation={setChangeLocation}
					/>
				)}
			</IonHeader>
		</React.Fragment>
	);
};

export default Header;
